import type { I18nFn } from '#/i18n/types/I18nFn';

import { LINE_ITEM_TYPES } from './constants/general/lineItemTypes';

export function getLineItemTypeName(i18n: I18nFn, typeId: string) {
  const type = LINE_ITEM_TYPES(i18n).find((t) => t.id === typeId);
  return type ? type.name : '';
}
